<template>
  <v-card
    class="pa-3 overflow-auto"
    width="100vw"
    max-width="850"
    max-height="100vh"
  >
    <v-row class="align-start">
      <v-col cols="12" xxl="8" xl="8" lg="8" md="8" sm="8">
        <v-card>
          <card-header></card-header>
          <v-card-title> {{ $t("product-preview.title") }} </v-card-title>

          <v-card-item>
            <template v-for="type in product?.product_types" :key="type">
              <event-card
                class="mx-2 my-3"
                v-if="
                  groupCategory.EVENT.includes(
                    product.product_category.productcategory_id
                  )
                "
                :type="type"
              ></event-card>
              <non-event-card
                class="mx-2 my-3"
                v-if="
                  groupCategory.NON_EVENT.includes(
                    product.product_category.productcategory_id
                  )
                "
                :type="type"
              ></non-event-card>
            </template>
          </v-card-item>

          <v-card-text>
            {{
              $t("product-preview.subtotal", totalCartQty, { n: totalCartQty })
            }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="sticky" cols="12" xxl="4" xl="4" lg="4" md="4" sm="4">
        <cart-detail></cart-detail>
      </v-col>
    </v-row>

    <v-divider class="border-opacity-50 mt-4" thickness="2"></v-divider>

    <v-card-item>
      <card-footer></card-footer>
    </v-card-item>
  </v-card>
</template>

<script>
import EventCard from "./product-card/EventCard.vue";
import NonEventCard from "./product-card/NonEventCard.vue";
import { groupCategory } from "@/config/productCategory";
import * as validation from "@/utils/validation";
import CardHeader from "@/components/header/CardHeader.vue";
import CardFooter from "@/components/footer/CardFooter.vue";
import CartDetail from "@/components/cart-detail/CartDetail.vue";

export default {
  components: { EventCard, NonEventCard, CardHeader, CardFooter, CartDetail },
  data() {
    return {
      validation: {
        quantity: validation.default.quantity,
        cart: validation.default.cart,
      },
      groupCategory: groupCategory,
    };
  },
  computed: {
    totalCartQty() {
      return this.$store.getters.totalCartQty;
    },
    product() {
      return this.$store.state.product;
    },
  },
};
</script>

<style>
</style>